import './component';
import './config';
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-blog-product-slider',
    label: 'acris-blog.elements.blogProductSlider.label',
    component: 'sw-cms-el-acris-blog-product-slider',
    configComponent: 'sw-cms-el-config-acris-blog-product-slider',
    previewComponent: 'sw-cms-el-preview-acris-blog-product-slider',
    defaultConfig: {
        displayMode: {
            source: 'static',
            value: 'standard',
        },
        elMinWidth: {
            source: 'static',
            value: '300px',
        },
        verticalAlign: {
            source: 'static',
            value: null,
        },
        boxLayout: {
            source: 'static',
            value: 'standard',
        },
        border: {
            source: 'static',
            value: false,
        },
        navigationArrows: {
            source: 'static',
            value: 'outside',
        },
        speed: {
            source: 'static',
            value: 300,
        },
        rotate: {
            source: 'static',
            value: false,
        },
        autoplayTimeout: {
            source: 'static',
            value: 5000,
        }
    },
    collect: Shopware.Service('cmsService').getCollectFunction(),
});